import { makeStyles } from "@material-ui/core/styles";

export const ModalSuccessStyles = makeStyles(() => ({
  successModalTitle: {
    color: "#189ab4",
  },
  successModalContent: {
    color: "#424242",
  },
}));
